# Route: /admin/reason-vocabularies/:id/edit
# Edit a draft reason vocabulary: name, display name, description, AND its
# reason codes. Permission: ReasonVocabulary:update (enforced by
# PUT /api/reasons/vocabularies/{id}; the detail-page Edit affordance routes
# here). Only Draft vocabularies are mutable. The detail page offers Edit only
# while `flags.canEdit` is true, and the form itself re-reads that same
# server-computed flag on load: a version reached by URL after it has left Draft
# renders read-only with a caution notice instead of inviting a save the server
# would reject (422 from ReasonVocabularyEndpoints.Update).
#
# Implementation: the SAME hand-authored widget the create page uses
# (`xp87-vocab-form`), in edit mode via `vocabulary-id`. The reason-code editor
# is a dynamic list the declarative Form type cannot express, and re-versioning
# exists precisely to change that list — so edit and create share one form
# rather than keeping a metadata-only twin beside it.

page-reason-vocabulary-edit:
  type: Page
  archetype: edit
  meta:
    title: $t.admin.reasons.edit.meta_title
    route: /admin/reason-vocabularies/:id/edit
    layout: shell
    auth: required
  params:
    id:
      type: string
      required: true
  spatial:
    display: flex
    direction: column
    gap: $spacing.xl
    padding: $spacing.lg
    padding_inline: $spacing.xl
    overflow: auto
    responsive:
      sm:
        padding: $spacing.sm
        padding_inline: $spacing.sm
        gap: $spacing.md
  tokens:
    background: $color_scheme.light.color.surface
  children:
    - reason-edit-header
    - reason-edit-form-host

# ── Header ───────────────────────────────────────────────────────────────────

reason-edit-header:
  type: PageHeader
  content: $t.admin.reasons.edit.title
  back_route: /admin/reason-vocabularies/:id

# ── Form host (the widget owns the form + validation) ────────────────────────

reason-edit-form-host:
  type: Widget
  ref: xp87-vocab-form
  params:
    vocabulary-id: $params.id
